export default __webpack_public_path__ + "static/media/GreenFrame04.9458f52a.png";